import classNames from 'classnames';

const getColor = (props) => {
  if (props.success) {
    return 'text-green-500';
  }
  if (props.danger) {
    return 'text-red-500';
  }
  return 'text-blue-500';
};

const StatusIcon = (props) => (
  <i className={classNames(props.className, getColor(props), 'mr-3')} />
);

export default StatusIcon;
